import type { CryptopediaAuthorType } from "types/cryptopedia";
import { Col, Row, Vstack } from "components/layout/Grid";
import Picture from "components/parts/Picture";
import {
  Paragraph3,
  Paragraph4
} from "components/parts/Typography/cryptopedia";
import NextLink from "components/parts/NextLink";
import * as React from "react";
import twitterIcon from "public/images/cryptopedia/cryptopedia_social_twitter.svg?inline&original";
import websiteIcon from "public/images/cryptopedia/cryptopedia_social_website.svg?inline&original";
import linkedInIcon from "public/images/cryptopedia/cryptopedia_social_linkedin.svg?inline&original";
import facebookIcon from "public/images/cryptopedia/cryptopedia_social_facebook.svg?inline&original";
import { AuthorSocial, SocialButtons, AuthorImage } from "./styles";
import TextLink from "components/parts/NextLink/TextLink";
import kebabCase from "lodash/kebabCase";

const CryptopediaAuthor = ({ author }: { author: CryptopediaAuthorType }) => {
  const {
    name,
    profileImage,
    jobTitle,
    bio,
    twitterUrl,
    linkedInUrl,
    websiteUrl,
    facebookUrl
  } = author;
  return (
    <Row>
      <Col sm={12} md={3} alignItems={"center"}>
        <AuthorImage>
          <Picture src={profileImage} alt={name} />
        </AuthorImage>
      </Col>
      <Col sm={12} md={9} alignItems={"center"}>
        <Vstack smSpacing={0} alignItems={"center"}>
          <Paragraph4 color={"secondary"}>Author</Paragraph4>
          <TextLink href={`/cryptopedia/authors#${kebabCase(name)}`}>
            <Paragraph3
              bold
              underline
              css={`
                margin: 4px 0 0;
              `}
            >
              {name}
            </Paragraph3>
          </TextLink>
          <Paragraph3
            color="secondary"
            css={`
              margin: 0 0 8px;
            `}
          >
            {jobTitle}
          </Paragraph3>
          <Paragraph3>{bio}</Paragraph3>
          <AuthorSocial>
            {(!!twitterUrl ||
              !!linkedInUrl ||
              !!facebookUrl ||
              !!websiteUrl) && (
              <Paragraph3 color={"secondary"}>Follow me on: </Paragraph3>
            )}
            <SocialButtons>
              {!!twitterUrl && (
                <NextLink href={twitterUrl}>
                  <img alt="twitter" src={twitterIcon} />
                </NextLink>
              )}
              {!!linkedInUrl && (
                <NextLink href={linkedInUrl}>
                  <img alt="linkedIn" src={linkedInIcon} />
                </NextLink>
              )}
              {!!facebookUrl && (
                <NextLink href={facebookUrl}>
                  <img alt="facebook" src={facebookIcon} />
                </NextLink>
              )}
              {!!websiteUrl && (
                <NextLink href={websiteUrl}>
                  <img alt={`${name}'s website'`} src={websiteIcon} />
                </NextLink>
              )}
            </SocialButtons>
          </AuthorSocial>
        </Vstack>
      </Col>
    </Row>
  );
};

export default CryptopediaAuthor;
